// Responsive images. The build resizes every photo to WebP at a few widths and lists them in
// src/generated/res.json (source path -> widths). These helpers pick from that list.
import RES from '../generated/res.json' with { type: 'json' };
import { esc } from './format.js';

let table = RES;
export const setResTable = (t) => { table = t; };            // tests
export const widths = (src) => table[src] || null;
export const variant = (src, w) => `/assets/_r/${src.replace(/^\/?assets\//, '').replace(/\.\w+$/, '')}-${w}.webp`;

export function srcset(src) {
  const ws = widths(src);
  return ws ? ws.map(w => `${variant(src, w)} ${w}w`).join(', ') : '';
}

// the smallest file at least `cssWidth` wide on this screen (for posters, backgrounds and the lightbox)
export function best(src, cssWidth, dpr = (typeof devicePixelRatio === 'number' ? devicePixelRatio : 1)) {
  const ws = widths(src); if (!ws) return src;
  const need = cssWidth * Math.min(dpr, 2);
  return variant(src, ws.find(w => w >= need) || ws[ws.length - 1]);
}

// <img> markup with srcset/sizes. Lazy images fade in once loaded (see the head script and site.css).
export function img(src, { alt = '', sizes = '100vw', cls = '', lazy = true, attrs = '' } = {}) {
  const ss = srcset(src);
  return `<img src="${esc(src)}"${ss ? ` srcset="${ss}" sizes="${sizes}"` : ''} alt="${esc(alt)}"${cls ? ` class="${cls}"` : ''}${lazy ? ' loading="lazy" decoding="async"' : ''}${attrs ? ' ' + attrs : ''}>`;
}
